export default __webpack_public_path__ + "43d199a751f14ae6a44d09906f3e5150.png";